module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325506/feature03-a5ba172d8cc02ca700f4e518909ee448.svg";